module.exports = __webpack_public_path__ + "static/media/ExpandIcon.811eb275.svg";